export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14746.2301ca19.jpg";